// 薪资明细
<template>
  <div class="threeLevelMain">
    <!-- 查询区域 -->
    <div class="queryBox clearfix">
      <div class="query_row">
        <div class="scan_box">
          <span class="sp_scan">日期：</span>
          <el-date-picker
            v-model="queryForm.time"
            class="ip_scan"
            size="mini"
            type="month"
            placeholder="选择月"
            @change="searchFunc"
            value-format="yyyy-MM"
          >
          </el-date-picker>
        </div>
        <div class="scan_box">
          <span class="sp_scan">部门：</span>
          <el-select
            v-model="queryForm.departmental_charge"
            class="ip_scan"
            size="mini"
            clearable
            @change="searchFunc"
          >
            <el-option
              v-for="dep in departmentOptions"
              :key="dep.value"
              :label="dep.label"
              :value="dep.label"
            ></el-option>
          </el-select>
        </div>
        <div class="scan_box">
          <span class="sp_scan">姓名：</span>
          <el-input
            v-model="queryForm.name"
            class="ip_scan"
            size="mini"
            @input="searchFunc"
          >
          </el-input>
        </div>
      </div>
      <!-- 按钮区域 -->
      <div class="btn_area_out">
        <el-button size="mini" @click="resetSearch">
          重置查询
        </el-button>

        <el-button size="mini" @click="openDialog">
          添加信息
        </el-button>

        <el-button size="mini" @click="openExport">
          导出看板
        </el-button>

        <div class="import_area">
          <el-button size="mini">
            导入信息
          </el-button>
          <input
            type="file"
            ref="importDom"
            class="import_file little_hands"
            @change="importHandle"
          />
        </div>

        <el-button size="mini" @click="importTem">
          下载导入模板
        </el-button>
      </div>
    </div>

    <!-- 内容区域 -->
    <tablePageComp
      :columnsList="columnsList"
      :dataList="dataList"
      :getDataConfig="dataQueryFunc()"
      :updateDataTag="updateDataTag"
      :orderNumConfig="{}"
      :totalCount="totalCount"
    >
      <el-table-column
        slot="departmental_charge"
        width="100"
        label="部门"
        align="center"
      >
        <template slot-scope="scope">
          <div>
            {{
              departmentOptions.filter(
                (r) => r.value == scope.row.departmental_charge
              )[0].label
            }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        slot="revise_handle"
        width="100"
        align="center"
        label="操作"
      >
        <template slot-scope="scope">
          <div>
            <el-button
              type="text"
              @click="openDialog(false, scope.row)"
              class="fontColor_warning"
              >修改</el-button
            >
          </div>
        </template>
      </el-table-column>
    </tablePageComp>

    <!-- 信息操作窗口 -->
    <el-dialog
      title="添加信息"
      :visible.sync="dialogVisible"
      width="800px"
      :before-close="dialogClose"
    >
      <!-- 财务操作 -->
      <el-form
        :model="formData"
        ref="formData"
        :rules="rules"
        label-width="100px"
        label-position="top"
        :inline="true"
        size="small"
        class="form-main"
        :hide-required-asterisk="true"
      >
        <el-form-item label="日期" prop="time" class="formItems">
          <el-date-picker
            class="s_time"
            v-model="formData.time"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="部门" prop="departmental_charge" class="formItems">
          <el-select v-model="formData.departmental_charge">
            <el-option
              v-for="dep in departmentOptions"
              :key="dep.value"
              :label="dep.label"
              :value="dep.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名" prop="name" class="formItems">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item label="底薪 + 绩效" prop="basic_salary" class="formItems">
          <el-input v-model="formData.basic_salary"></el-input>
        </el-form-item>
        <el-form-item label="业绩提成" prop="push_money" class="formItems">
          <el-input v-model="formData.push_money"></el-input>
        </el-form-item>
        <el-form-item label="应发工资" prop="salary" class="formItems">
          <el-input v-model="formData.salary"></el-input>
        </el-form-item>
        <el-form-item
          label="个人所得税"
          prop="personal_income_tax"
          class="formItems"
        >
          <el-input v-model="formData.personal_income_tax"></el-input>
        </el-form-item>
        <el-form-item
          label="个人社保"
          prop="pension_deduction_etc"
          class="formItems"
        >
          <el-input v-model="formData.pension_deduction_etc"></el-input>
        </el-form-item>
        <el-form-item
          label="企业社保"
          prop="enterprise_deduction_etc"
          class="formItems"
        >
          <el-input v-model="formData.enterprise_deduction_etc"></el-input>
        </el-form-item>
        <el-form-item
          label="个人公积金"
          prop="personal_accumulation_fund"
          class="formItems"
        >
          <el-input v-model="formData.personal_accumulation_fund"></el-input>
        </el-form-item>
        <el-form-item
          label="企业公积金"
          prop="enterprise_accumulation_fund"
          class="formItems"
        >
          <el-input v-model="formData.enterprise_accumulation_fund"></el-input>
        </el-form-item>
        <el-form-item label="实发工资" prop="take_home_pay" class="formItems">
          <el-input v-model="formData.take_home_pay"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false" :loading="btnLoading"
          >取 消</el-button
        >
        <el-button
          type="primary"
          :loading="btnLoading"
          @click="submitForm('formData')"
          >提交</el-button
        >
      </span>
    </el-dialog>

    <el-dialog title="选择导出看板类型" :visible.sync="popUpVis" width="600px">
      <div class="select_box">
        <div class="export_type">
          <span class="e_t">导出类型：</span>
          <div class="all_type">
            <el-radio-group v-model="exportType" @change="exTypeChange">
              <el-radio label="1">年度薪酬汇总</el-radio>
              <el-radio label="2">月度薪酬汇总</el-radio>
            </el-radio-group>
          </div>
        </div>
        <!-- 导出条件选择 -->
        <div class="export_condition">
          <div class="e_c_items" v-show="exportType == '1'">
            <span class="ec_items_label">年份：</span>
            <el-date-picker
              size="small"
              v-model="exportParams.year"
              type="year"
              placeholder="选择年份"
              value-format="yyyy"
            >
            </el-date-picker>
          </div>
          <div class="e_c_items" v-show="exportType == '2'">
            <span class="ec_items_label">月份：</span>
            <el-date-picker
              size="small"
              v-model="exportParams.time"
              type="month"
              placeholder="选择月份"
              value-format="yyyy-MM"
            >
            </el-date-picker>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="popUpVis = false" :loading="btnLoading"
          >取 消</el-button
        >
        <el-button type="primary" :loading="btnLoading" @click="exportBtn"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api";
import utils from "@/libs/utils.js";
export default {
  data() {
    let userId = utils.sessionGetStore("user_id");
    let userName = utils.sessionGetStore("user_name");
    let numberValidate = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入内容"));
      } else {
        // 保留两位小数
        if (/^(([1-9][0-9]*)|((([1-9][0-9]*)|0)\.[0-9]{1,2}))$/.test(value)) {
          callback();
        } else {
          callback(new Error("请输入纯数字或保留2位小数"));
        }
      }
    };
    return {
      userId: userId,
      userName,
      // 列表查询条件
      queryForm: {
        departmental_charge: "", // 所属部门
        time: "",
        name: "",
      },
      // 表格内容相关
      dataList: [],
      updateDataTag: false,
      totalCount: 0, // 数据总条数
      columnsList: [
        {
          label: "修改操作",
          slotName: "revise_handle",
        },
        {
          label: "日期",
          prop: "time",
          width: 100,
        },
        {
          label: "部门",
          // slotName:"departmental_charge"
          prop: "departmental_charge",
          width: 100,
        },
        {
          label: "姓名",
          prop: "name",
          width: 100,
        },
        {
          label: "底薪 + 绩效",
          prop: "basic_salary",
          width: 180,
        },
        {
          label: "业绩提成",
          prop: "push_money",
          width: 100,
        },
        {
          label: "应发工资",
          prop: "salary",
          width: 100,
        },

        {
          label: "个人所得税",
          prop: "personal_income_tax",
          width: 100,
        },
        {
          label: "个人社保",
          prop: "pension_deduction_etc",
          width: 120,
        },
        {
          label: "企业社保",
          prop: "enterprise_deduction_etc",
          width: 180,
        },
        {
          label: "	个人公积金",
          prop: "personal_accumulation_fund",
          width: 180,
        },
        {
          label: "企业公积金",
          prop: "enterprise_accumulation_fund",
          width: 100,
        },
        {
          label: "实发工资",
          prop: "take_home_pay",
          width: 100,
        },
        {
          label: "提交人",
          prop: "submitter",
          width: 100,
        },
        {
          label: "添加时间",
          prop: "add_time",
          width: 150,
        },
      ],

      // 弹窗相关
      dialogVisible: false,
      isAdd: true, // 是否是添加信息操作
      formData: {
        time: "", // 日期
        departmental_charge: "", // 部门
        name: "", // 姓名
        basic_salary: "", // 底薪 + 绩效
        push_money: "", // 业绩提成
        salary: "", // 应发工资
        personal_income_tax: "", // 个人所得税
        pension_deduction_etc: "", // 个人社保
        enterprise_deduction_etc: "", // 企业社保
        personal_accumulation_fund: "", // 个人公积金
        enterprise_accumulation_fund: "", // 企业公积金
        take_home_pay: "0.00", // 实发工资

        // 待修改信息id
        id: "",
      },
      rules: {
        time: [{ required: true, message: "请填入日期", trigger: "change" }],
        name: [{ required: true, message: "请填入姓名", trigger: "blur" }],
        departmental_charge: [
          { required: true, message: "请填入部门", trigger: "change" },
        ],
        basic_salary: [{ validator: numberValidate, trigger: "blur" }],
        push_money: [{ validator: numberValidate, trigger: "blur" }],
        salary: [{ validator: numberValidate, trigger: "blur" }],
        personal_income_tax: [{ validator: numberValidate, trigger: "blur" }],
        pension_deduction_etc: [{ validator: numberValidate, trigger: "blur" }],
        enterprise_deduction_etc: [
          { validator: numberValidate, trigger: "blur" },
        ],
        personal_accumulation_fund: [
          { validator: numberValidate, trigger: "blur" },
        ],
        enterprise_accumulation_fund: [
          { validator: numberValidate, trigger: "blur" },
        ],
        take_home_pay: [{ validator: numberValidate, trigger: "blur" }],
        // total_money: [
        //     { validator: numberValidate, trigger: 'blur' },
        // ],
        // account_balance: [
        //     { validator: numberValidate, trigger: 'blur' },
        // ],
      },

      btnLoading: false,

      // 导出信息弹窗
      popUpVis: false,
      exportType: "1", // 导出类型 默认第一个
      exportParams: {
        year: "",
        time: "",
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      yearOptions: [],
    };
  },

  computed: {
    // 部门配置项
    departmentOptions() {
      return [...this.$store.state.commonOptions.department];
    },
  },

  created() {
    let date = new Date();
    for (let i = 0; i < 5; i++) {
      this.yearOptions.push(date.getFullYear() - i);
    }
  },
  methods: {
    importTem() {
      window.location.href =
        "https://baibooa.oss-cn-hangzhou.aliyuncs.com/oa_xlsx/%E8%96%AA%E9%85%AC%E6%98%8E%E7%BB%86%E6%A8%A1%E6%9D%BF.xlsx";
    },
    // 导入
    importHandle(e) {
      let file = e.target.files[0];
      let formData = new FormData();
      formData.append("file", file);
      formData.append("submitter", this.userName);
      formData.append("file_url", e.target.value);
      this.$refs.importDom.value = null;

      const loading = this.$loading({
        lock: true,
        text: "导入中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      api
        .importSalaryDetails(formData)
        .then((res) => {
          loading.close();
          // console.log(res)
          if (res.data.code == 0) {
            utils.notificationInfo("消息", "已导入", "success");
            this.updateDataTag = !this.updateDataTag;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((error) => {
          loading.close();
          console.log(error);
        });
    },
    // 导出类型变化
    exTypeChange() {
      Object.keys(this.exportParams).forEach((key) => {
        this.exportParams[key] = "";
      });
    },
    exportBtn() {
      if (this.exportType == "1" && this.exportParams.year === "") {
        this.$message.warning("未选择年份");
        return;
      }
      if (this.exportType == "2" && this.exportParams.time === "") {
        this.$message.warning("未选择月份");
        return;
      }
      let paramObj = {};
      Object.keys(this.exportParams).forEach((key) => {
        if (this.exportParams[key]) {
          paramObj[key] = this.exportParams[key];
        }
      });

      let apiName = "";
      switch (this.exportType) {
        case "1":
          apiName = "exportYearPayrollCollect";
          break;
        case "2":
          apiName = "exportMonthPayrollCollect";
          break;
      }
      const loading = this.$loading({
        lock: true,
        text: "正在导出",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      api[apiName](paramObj)
        .then((res) => {
          // console.log(res)
          loading.close();
          utils.downloadFile(res);
          this.popUpVis = false;
        })
        .catch((error) => {
          console.log(error);
          loading.close();
          this.$message.error("导出失败");
        });
    },

    // 导出窗口
    openExport() {
      this.popUpVis = true;
      Object.keys(this.exportParams).forEach((key) => {
        this.exportParams[key] = "";
      });
    },

    searchFunc() {
      utils.debounceFunc(
        function() {
          this.updateDataTag = !this.updateDataTag;
        }.bind(this),
        300
      );
    },

    //重置查询
    resetSearch() {
      Object.keys(this.queryForm).forEach((key) => {
        if (this.queryForm[key]) {
          this.queryForm[key] = "";
        }
      });
      this.updateDataTag = !this.updateDataTag;
    },

    //  弹窗添加信息
    openDialog(type = true, data) {
      this.dialogVisible = true;
      this.isAdd = type;

      if (this.isAdd) {
        // 添加
        Object.keys(this.formData).forEach((key) => {
          if (key == "name" || key == "departmental_charge" || key == "id") {
            this.formData[key] = "";
          } else if (key == "time") {
            this.formData.time = utils.getNowTime().split(" ")[0];
          } else {
            this.formData[key] = "0.00";
          }
        });
      } else {
        // 修改
        Object.keys(this.formData).forEach((key) => {
          if (data[key] == null || data[key] === "0") {
            if (key == "name" || key == "departmental_charge") {
              this.formData[key] = "";
            } else {
              this.formData[key] = "0.00";
            }
          } else {
            this.formData[key] = data[key];
          }
        });
      }
    },

    // 确认提交信息----财务或市场部提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let paramObj = {};
          Object.keys(this.formData).forEach((key) => {
            if (this.formData[key]) {
              paramObj[key] = this.formData[key];
            }
          });
          this.btnLoading = true;
          let apiName = "";
          if (this.isAdd) {
            paramObj.submitter = this.userName;

            apiName = "addSalaryDetails";
          } else {
            // 修改
            apiName = "modifySalaryDetails";
          }
          api[apiName](paramObj)
            .then((res) => {
              // console.log(res)
              this.btnLoading = false;
              if (res.data.code === 0) {
                this.updateDataTag = !this.updateDataTag;
                this.dialogVisible = false;
                utils.notificationInfo("提示", "提交成功", "success");
              } else {
                this.$message.warning(res.msg);
              }
            })
            .catch((error) => {
              console.log(error);
              this.btnLoading = false;
              this.$message.warning("信息提交失败");
            });
        } else {
          return false;
        }
      });
    },

    dialogClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },

    //表格数据获取
    dataQueryFunc() {
      //查询条件
      let paramObj = {};
      Object.keys(this.queryForm).forEach((key) => {
        if (this.queryForm[key]) {
          paramObj[key] = this.queryForm[key];
        }
      });

      return {
        apiName: "salaryDetailsList",
        paramObj: paramObj,
        success: function(response, callBack) {
          // console.log(response)
          let records = response.data.data.list;
          let arr = [];
          for (let i = 0; i < records.length; i++) {
            let obj = records[i];

            Object.keys(obj).forEach((key) => {
              if (obj[key] == null || obj[key] == undefined) {
                obj[key] = "";
              }
            });

            arr.push(obj);
          }
          this.dataList = arr;
          this.totalCount = response.data.data.totalCount;

          if (callBack) {
            callBack();
          }
        }.bind(this),
        failed: function(error, callBack) {
          if (callBack) {
            callBack();
          }
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.threeLevelMain {
  .queryBox {
    margin-bottom: 2px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;

    // 金额筛选
    .amount {
      display: flex;
      align-items: center;
      justify-content: center;
      > div {
        margin: 0 !important;
      }
    }
  }
}
.form-main {
  // text-align: center;
  padding-left: 26px;

  .formItems {
    padding: 0 20px;
    padding-right: 40px;
    width: 30%;
    text-align: left;

    .s_time {
      width: 150px;
    }
    .bank_select {
      width: 350px;
    }
  }
}

// 选择导出看板类型样式
.select_box {
  padding: 0 20px;
  .export_type {
    .e_t {
      font-size: 15px;
      font-weight: bold;
    }
    .all_type {
      margin: 20px 0;
      padding: 0 20px;
    }
  }

  .export_condition {
    margin-top: 30px;
    .e_c_items {
      padding: 10px 20px;
      line-height: 30px;

      .ec_items_label {
        display: inline-block;
        width: 70px;
        text-align: right;
        padding-right: 5px;
      }

      .bn_select {
        width: 350px;
      }
    }
  }
}
</style>
